import type { ConsoleFaq } from '@aithora/shared';
import { takeWindowData } from './takeWindowData';

// The console FAQ ("how do I do this", mid-task). SOURCE: the Sep 16 copy the design
// ships as a script that sets window.CONSOLE_FAQ. Swapping in the new copy is this one
// import line.
import '../../../../design-preview/console-faq-data.js';

export const CONSOLE_FAQ: ConsoleFaq = takeWindowData<ConsoleFaq>('CONSOLE_FAQ', { groups: [] });
